<template>
  <button class="header-btn" :class="{ 'is-unread': !hasNotification }" @click="readNew">
    <i class="icon icon-bell"></i>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

const store = useStore();
const route = useRoute();
const router = useRouter();

const hasNotification = computed(() => store.getters['common/hasNotification'] == 1);

const readNew = () => {
  store.dispatch('event/getParentEventInfo');
  if (route.name !== 'NewsOfficial' && route.name !== 'NewsShop') {
    router.push({ name: 'NewsOfficial' });
  }
};
</script>
